// src/firebase.js
import { initializeApp }    from "firebase/app";
import { getAuth, connectAuthEmulator }          from "firebase/auth";
import { getFirestore, connectFirestoreEmulator }     from "firebase/firestore";
import { getStorage, connectStorageEmulator }       from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';
const emulatorProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;

const firebaseConfig = {
  apiKey: "AIzaSyCcj66kuDbzIbPt8j7w0t2WZ1Y8jpmCR_I",
  authDomain: "email-automation-cache.firebaseapp.com",
  projectId: useEmulators && emulatorProjectId
    ? emulatorProjectId
    : "email-automation-cache",
  storageBucket: "email-automation-cache.firebasestorage.app",
  messagingSenderId: "248289505828",
  appId: "1:248289505828:web:590cfeb2310cd8d3e51eb1",
  measurementId: "G-MSGL976VZ7"
};

// Initialize the Firebase App once
const app = initializeApp(firebaseConfig);

// Export the individual services
export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

if (useEmulators) {
  console.log('🧪 Connecting to Firebase Emulators...');

  // Connect to Auth Emulator
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });

  // Connect to Firestore Emulator
  connectFirestoreEmulator(db, 'localhost', 8080);

  // Connect to Functions Emulator
  connectFunctionsEmulator(functions, 'localhost', 5001);

  // Connect to Storage Emulator (optional)
  connectStorageEmulator(storage, 'localhost', 9199);

  console.log('✅ Connected to Firebase Emulators');
}

// Export test mode flag for components to use
export const isTestMode = useEmulators;
